import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import GeneralTextInput from '../../../common/components/GeneralTextInput/generalTextInput'
import CustomSelect from '../../../common/components/SimpleInputs/CustomSelect/CustomSelect'
import { Icon } from '../../../common/styles/global_styles'
import { SheetField } from '../../../common/types/api/excel'
import { OptionType } from '../../../common/types/utilities'

interface Props {
    options: OptionType[]
    field: SheetField
    update: (field: SheetField) => void
    remove: () => {}
    id: number
}

function numToSSColumn(num: number): string {
    let s = '', t;

    while (num > 0) {
        t = (num - 1) % 26;
        s = String.fromCharCode(65 + t) + s;
        num = (num - t) / 26 | 0;
    }
    return s || undefined;
}

export default function SettingsColumns({ field, options, remove, id, update }: Props): JSX.Element {

    return <ContainerSelect key={`--column-${id}`}>
        <ColumnInfo>
            <span> Column: <label>{numToSSColumn(id + 1)}</label>
            </span> <Icon className={'far fa-trash-alt trash_button'} onClick={() => remove()} />
        </ColumnInfo>
        <CustomSelect
            closeMenuOnSelect={true}
            isClearable={false}
            editMode={true} value={{ label: field?.name, value: field?.name }} onChange={({ value }) => {                
                if(!!value)
                    update({ ...field, name: value })
            }} options={options} required={false} />
        <GeneralTextInput
            variant={'primary'}
            border={true}
            error={false}
            editMode={true}
            placeholder={i18n('format')}
            required={false}
            value={field?.format}
            onChange={name => {
                update({name:field?.name,format:name})
             }}
        />
    </ContainerSelect >

}



const ColumnInfo = styled.div`    
    height: 30px;
    display: flex;
    width:100%;
    justify-content: space-between;
    padding:4px;
    span{
        label{
            display: inline;
        }
    }
    border:1px solid rgb(186, 192, 203);
    border-radius: 3px;
`
const ContainerSelect = styled.div`
    width:160px;
    padding-right: 10px;
    padding-top:10px;
    z-index: 0;
    position: relative;
    ${Icon}{
        color:red;        
        right:10px;
        transition: .2s;
        padding: 4px;
        border-radius: 3px;
        align-self: flex-end;        
        :hover{
            color:white;
            background-color: red;
        }
    }
    >div{
        min-height: auto;
    }
    .primary_generalTextInput{
        height: 32px;
        >div{
            height:auto;

        }
    }
`